// Generated by Melange

import * as StoreFx__PlayerContext from "./playerContext.jsx";

function make(param) {
  return {
    TAG: /* Ok */ 0,
    _0: (StoreFx__PlayerContext.audio.pause(), undefined)
  };
}

export {
  make,
}
/* StoreFx__PlayerContext Not a pure module */
